export default {
  // pass class name of elements to be equalized, eg: sku.equalizeHeight('.someClass')
  equalizeHeightFlag: [],
  equalizeHeight (className) {
    let doIt = (className) => {
      let maxHeight = 0
      let el = document.querySelectorAll(className)
      el.forEach(element => (element.style.height = 'auto'))
      el.forEach(element => { if (element.offsetHeight > maxHeight) maxHeight = element.offsetHeight })
      el.forEach(element => (element.style.height = maxHeight + 'px'))
    }
    doIt(className)

    if (!this.equalizeHeightFlag.includes(className)) {
      window.addEventListener('resize', () => doIt(className))
      this.equalizeHeightFlag.push(className)
    }
  },
  // pass unique element to copy dimensions from first to second, eg: sku.animateAutoWidthAndHeight('.someClass') in mounted hook of every view (element must have background-color - not background: shorthand)
  animateAutoWidthAndHeight (copyFrom) {
    let transparentDiv = document.querySelector(copyFrom) // div with BG none that gives width to the visible one
    let visibleDiv
    let isDivAppended = false
    if (transparentDiv.nextElementSibling) {
      if (transparentDiv.nextElementSibling.className === 'visible-div') {
        isDivAppended = true
      }
    }
    if (!isDivAppended) {
      transparentDiv.insertAdjacentHTML('afterend', '<div class="visible-div"></div>')
      visibleDiv = transparentDiv.nextElementSibling
      let theCSSprop = window.getComputedStyle(transparentDiv, null).getPropertyValue('background-color')
      visibleDiv.style.backgroundColor = theCSSprop
      transparentDiv.style.background = 'none'
      transparentDiv.style.zIndex = 2
      visibleDiv.style.position = 'absolute'
      visibleDiv.style.zIndex = 1
      visibleDiv.style.transition = 'width 300ms ease, height 300ms ease'
      visibleDiv.style.transform = 'translate(-50%, -50%)'
      visibleDiv.style.opacity = 0.8
    }
    visibleDiv = transparentDiv.nextElementSibling

    let doIt = () => {
      visibleDiv.style.width = transparentDiv.offsetWidth + 'px'
      visibleDiv.style.height = transparentDiv.offsetHeight + 'px'
      visibleDiv.style.left =
        transparentDiv.offsetLeft + transparentDiv.offsetWidth / 2 + 'px'
      visibleDiv.style.top =
        transparentDiv.offsetTop + transparentDiv.offsetHeight / 2 + 'px'
    }
    doIt()

    if (!isDivAppended) {
      window.addEventListener('resize', doIt)
    }
  }
}
